import {getCountry, getWithDotComByCountry} from '../store/util';

const country = getCountry();
const withCom = getWithDotComByCountry(country);

export const env = {
  NODE_ENV: 'development',
  CLIENT_ID: 'neodash_qa',
  URL: {
    HOST: `https://neodash.qa.neogig${withCom}${country}`,
    NEOGIG: `https://qa.neogig${withCom}${country}`,
    NEOGIG_API: `https://neogig-api.qa.neogig${withCom}${country}/api/v1`,
    NEOGIG_IMAGE: `https://qa.neogig${withCom}${country}/static/images`,
    NEODASH_API: `https://neodash-api.qa.neogig${withCom}${country}`,
    REPORT_VIEWER: `https://reportviewer.qa.neogig${withCom}${country}`,
    CTRL_PANEL_API: `https://cp-api.qa.neogig${withCom}${country}`,
    IDENTITY_SERVER: `https://identity-server.qa.neogig${withCom}${country}`,
    WEBSOCKET: `ws://neodash-api.qa.neogig${withCom}${country}/WsSocketHandler.ashx`,
    PBIURL: `https://app.powerbi.com/`,
  }
};
